/* tslint:disable */
/* eslint-disable */
/**
 * School Reporting Systems API
 * School Reporting Systems.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: tony.henderson@elevenfiftynine.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */
export enum FilterCriteriaValue {
    stringVal = 'StringVal',
    intVal = 'IntVal',
    floatVal = 'FloatVal',
    boolVal = 'BoolVal'
}



